import * as types from '../actions';

export function getTodoList(params = {}) {
  return {
    type: types.TODO_GET_LIST,
    payload: params,
  };
}

export function addTodoItem(item) {
  return {
    type: types.TODO_ADD_ITEM,
    payload: item,
  };
}

export function selectTodoItems(items) {
  return {
    type: types.TODO_SELECTED_ITEMS_CHANGE,
    payload: items,
  };
}

export default {
  getTodoList,
  addTodoItem,
  selectTodoItems,
};
